import React from 'react';

const CloseNotificationIcon = props => {
    return (
        <svg xmlns='http://www.w3.org/2000/svg' width='34' height='34' viewBox='0 0 34 34' {...props}>
            <g fill='#1D1D1B'>
                <path d='M17 28c6.075 0 11-4.925 11-11S23.075 6 17 6 6 10.925 6 17s4.925 11 11 11z' opacity='.146' />
                <path d='M18.206 17.1L20.913 19.837 19.707 21.055 17 18.319 14.294 21.055 13.088 19.836 15.795 17.1 13 14.275 14.206 13.055 17 15.881 19.794 13.055 21 14.275z' />
            </g>
        </svg>
    );
};

export default CloseNotificationIcon;
